import { TemplateConfig } from '../types';

export const venusSpreadConfig: TemplateConfig = {
  id: 'venus-spread',
  name: '维纳斯牌阵',
  description: '对爱情问题进行占卜，对双方深层潜意识进行剖析和比较，对未来发展中的阻碍和结果进行预测性的呈现',
  cardCount: 8,
  
  fieldDefaults: {
    title: '维纳斯牌阵',
    customerQuestion: '对爱情问题进行占卜，对双方深层潜意识进行剖析和比较，对未来发展中的阻碍和结果进行预测性的呈现。',
    cardPlaceholders: [
      '请输入第 1 列第 1 张牌',
      '请输入第 3 列第 1 张牌',
      '请输入第 2 列第 1 张牌',
      '请输入第 2 列第 2 张牌',
      '请输入第 2 列第 3 张牌',
      '请输入第 2 列第 4 张牌',
      '请输入第 1 列第 2 张牌',
      '请输入第 3 列第 2 张牌'
    ],
    cardInfos: [
      '自己的看法',
      '对方的心态',
      '自己的影响',
      '对方的影响',
      '障碍',
      '结果',
      '自己未来的看法',
      '对方未来的看法'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#eb2f96',
    backgroundColor: '#fff0f6',
    icon: '💕'
  }
};